import React, { useEffect, useState } from "react"
import { Typography, Box } from "@carrotfertility/carotene-core"
import { CenteredLoadingIndicator } from "#/components/views/molecules/Molecules"
import { useStateMachine } from "#/components/context/stateMachine/StateMachineContext"
import { Steps } from "#/components/cmd-enrollment/workflow/steps"
import { EnrollmentType, useEnrollmentFlowModal } from "#/components/cmd-enrollment/EnrollmentModal"
import { carrotClient } from "#/utils/CarrotClient"
import { useUserDeductible } from "#/components/context/user/DeductibleContext"
import { FormattedMessage } from "react-intl"
import { useProgressTracker } from "../../../views/modal/ProgressTracker"

export default function ProcessEnrollmentTypeStep(): JSX.Element {
  const viewName = Steps.PROCESS_ENROLLMENT_TYPE
  const { refreshUserBenefitEnrollment } = useUserDeductible()
  const { enrollmentType } = useEnrollmentFlowModal()

  const { showProgress } = useProgressTracker()
  useEffect(showProgress, [showProgress])

  const { setNextStep } = useStateMachine(viewName, null)
  const [loading, setLoading] = useState(true)

  const resetBenefitEnrollment = async (): Promise<void> => {
    await carrotClient.triggerQleEnrollment()
    await refreshUserBenefitEnrollment()
  }

  const resetInsuranceEnrollment = async (): Promise<void> => {
    await carrotClient.triggerInsuranceEdit()
    await refreshUserBenefitEnrollment()
  }

  useEffect(() => {
    const execute = async (): Promise<void> => {
      switch (enrollmentType) {
        case EnrollmentType.INSURANCE_EDIT:
          await resetInsuranceEnrollment()
          break
        case EnrollmentType.QLE_RE_ENROLLMENT:
          await resetBenefitEnrollment()
          break
        default:
          break
      }
      setLoading(false)
    }
    execute()
    // eslint-disable-next-line react-hooks/exhaustive-deps -- See https://carrotfertility.atlassian.net/wiki/spaces/PE/pages/2050295461/Remove+Build+Warnings#react-hooks%2Fexhaustive-deps
  }, [])

  useEffect(() => {
    if (!loading) {
      setNextStep(viewName, "")
    }
  }, [loading, setNextStep, viewName])

  return (
    <Box display="flex" alignItems="center" flexDirection="column" paddingY="2.25rem">
      <CenteredLoadingIndicator />
      <Typography
        id="step-heading"
        variant="h2"
        color={(theme) => theme.palette.text.primary}
        paddingBottom={(theme) => theme.tokens.spacing.lg}
      >
        <FormattedMessage defaultMessage="We're working on your request." />
      </Typography>
    </Box>
  )
}
